<script>
import {
    Selection,

} from "prosemirror-state";
export default {
    name: 'GeneralHelpers',

    data() {
        return {
            floatingMenuState: 'plus',
        }
    },
    methods: {

        getTitle() {
            var title_text = this.editor.state.doc.content.content[0].textContent;
            return title_text;
        },
        getBody() {
            var body_text = "";
            var content_len = this.editor.state.doc.content.content.length;
            for (var i = 0; i < content_len; i++) {
                body_text += " " + this.editor.state.doc.content.content[i].textContent;
            }
            return body_text;
        },

        setContent() {
            this.editor.setContent(this.content);
        },
        goToContent() {
            var state = this.editor.state;
            var select = Selection.atStart(state.doc);
            this.editor.view.dispatch(state.tr.setSelection(select));
        },
        goToBody() {
            var state = this.editor.state;
            var pos = state.doc.resolve(state.doc.content.content[0].content.size + 2);
            this.editor.view.dispatch(state.tr.setSelection(Selection.near(pos)));
        },
        goToEnd() {
            var state = this.editor.state;
            var select = Selection.atEnd(state.doc);
            this.editor.view.dispatch(state.tr.setSelection(select));
        },
        getFontSize() {
            return parseFloat(getComputedStyle(this.$el).fontSize)

        },
        turnOffFloatingMenu() {
            this.floatingMenuState = "off"
        },

        toggleFloatingMenu() {
            if (this.floatingMenuState == "menu" || this.floatingMenuState == "off") {
                this.floatingMenuState = "plus";
            } else {
                this.floatingMenuState = "menu";
            }
        },

        deleteSelected() {
            {
                const position = this.editor.state.selection.anchor;
                var transaction = this.editor.state.tr.deleteSelection();
                this.editor.view.dispatch(transaction);
            }
        }
    },

    watch: {

        'editor.state.selection': function (newVal, oldVal) {

            var pos = this.editor.state.selection.anchor

            const cursorBoundings = this.editor.view.coordsAtPos(pos)

            //this logic is here to hide the floating menu 
            //in the case that our cursor is in a wrapped P
            if (cursorBoundings.x) {

                var editorOffset = this.$refs.editorContent.$el.getBoundingClientRect().x;
                var editorWidth = this.$refs.editorContent.$el.offsetWidth;
                var cursorX = cursorBoundings.x;

                //get our cursor position in the editor and check
                // if its greater than half of the editor width
                var editingWrappedText = cursorX - editorOffset > editorWidth / 2;

                if (editingWrappedText) {
                    this.turnOffFloatingMenu();
                    return;
                }

            }

            //if someone has the floating menu open
            //close it when they change selection
            if (this.floatingMenuState == "menu" || this.floatingMenuState == "off") {
                this.toggleFloatingMenu();
            }
            //scroll down before the cursor gets to the very very bottom of the page
            var cursorHeight = cursorBoundings.top;
            var bottomOfViewportHeight = window.innerHeight;

            if (bottomOfViewportHeight - cursorHeight < 100 && this.editor.focused && pos != this.previousPos) {
                this.previousPos = pos;
                window.scrollBy(0, this.getFontSize() * 1.9);
            }

        },
    },

    computed: {
        emptyParagraphSelected() {
			//this computed returns if we have selected a base level empty paragraph
			//our plus uses this to determine whether to show up or not

			//'resolved' is our current prosemirror resolved position
			//with it we can find out what our parent node is and information about it
            var selection = this.editor.state.selection;
            var position = selection.$cursor ? selection.$cursor.pos : selection.$from.pos;
            var resolved = this.editor.state.doc.resolve(position);
			
			//resolved.parent -- makes sure we have a parent
			//resolved.parent.type.name == "paragraph" -- our parent is a paragraph
			//resolved.parent.content.size == 0 -- our parent paragraph is empty
			//resolved.depth==1 -- makes sure our paragraph is on the base depth (meaning it's not a p in a table or something)
            return resolved.parent && resolved.parent.type.name == "paragraph" && resolved.parent.content.size == 0 &&resolved.depth==1;
        }
    }

}
</script>
